import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { replaceSearchIfChanged } from 'app/Utils/listQuerySync'

// Re-export list→detail return helpers so consumers can import from one place
export {
  pushDetailKeepingList,
  resolveListReturn,
} from 'app/Utils/listQuerySync'


/**
 * Read list page (+ optional open-record id) from the URL.
 * Use for useState initializers — never hydrate page in an effect
 * (that races the first fetch and leaves the UI on page 1).
 */
export function readListQuery(search = window.location.search) {
  const params = new URLSearchParams(search || ``)
  const page = parseInt(params.get(`page`) || `1`, 10)
  const id = params.get(`id`)
  return {
    page: Number.isFinite(page) && page > 0 ? page : 1,
    id: id || undefined,
    isOpen: Boolean(id),
  }
}

/**
 * Persist list page (+ optional open drawer/modal id) in the URL via replace.
 * Preserves any other query keys already on the location (filters, formType, etc.).
 *
 * @param {object} opts
 * @param {string} opts.pathname - e.g. `/projects`
 * @param {number} opts.page - current list page (1-based)
 * @param {string|number} [opts.id] - open record id
 * @param {boolean} [opts.isOpen] - whether the record UI is open
 */
export function useListUrlSync({ pathname, page = 1, id, isOpen = false }) {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (location.pathname !== pathname) return
    const params = new URLSearchParams(location.search)
    if (page > 1) params.set(`page`, String(page))
    else params.delete(`page`)
    if (isOpen && id) params.set(`id`, String(id))
    else params.delete(`id`)
    replaceSearchIfChanged(
      history,
      pathname,
      params.toString(),
      location.search,
    )
  }, [pathname, page, id, isOpen, history, location.pathname, location.search])
}
